import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

interface PreviewNotAvailableProps {
  fileContentType: string;
  fileExtension: string;
}

export function PreviewNotAvailable(props: PreviewNotAvailableProps) {
  const { fileContentType, fileExtension } = props;

  useLogEffect(APP_V2_USER_EVENTS.FILE_PREVIEW_NOT_AVAILABLE, {
    fileContentType,
    fileExtension,
  });

  return (
    <Stack spacing={5} sx={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
      <Illustration type="document-upload" />
      <Text
        semibold
        variant="h6"
        sx={(theme) => ({ color: theme.palette.text.secondary, textAlign: "center" })}
      >
        Preview not available
      </Text>
    </Stack>
  );
}
